import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CustomerModel } from '@shared/model/customerModels/customer-model';
import { EImageType, ImagePipe } from '@shared/pipes/image.pipe';
import { IFollowStateData } from "../../../follow-btn/pipe/follow-user-data.pipe";
import { UserTypeEnum } from '@shared/model/enum/user-type-enum';
import { FollowItemService } from '@shared/service/follow-item.service';

@Component({
  selector: 'beh-share-profile-dialog',
  imports: [ImagePipe],
  templateUrl: './share-profile-dialog.component.html',
  styleUrl: './share-profile-dialog.component.scss'
})
export class ShareProfileDialogComponent {
  private followItemService = inject(FollowItemService);
  data = inject<CustomerModel>(MAT_DIALOG_DATA);
  private dialogRef = inject<MatDialogRef<ShareProfileDialogComponent>>(MatDialogRef);

  imageType = EImageType;

  FollowClicked(item: IFollowStateData) {
    item.userType = UserTypeEnum.User;
    this.followItemService.Follow(item);
  }


  closeDialog() {
    this.dialogRef.close();
  }


}
